import * as Sentry from '@sentry/nextjs'

export const tagOutboundURL = (url: string): string => {
  try {
    const urlWithHost = url.match(/^https?:\/\//) ? url : `http://${url}`
    const parsedURL = new URL(urlWithHost)

    if (!parsedURL.searchParams.get('utm_source')) {
      parsedURL.searchParams.set('utm_source', 'thingtesting.com')
    }

    return parsedURL.toString()
  } catch (err) {
    Sentry.captureException(err, {
      level: Sentry.Severity.Warning
    })
    return url
  }
}
